module.exports = __webpack_public_path__ + "images/FUSA_icons/078-box-3.26d00b8c5dcfcb0459ee4db738524837.svg";